import {useState} from 'react'
import Spinner from '../Spinner/Spinner'
// import { Getter, Setter } from '../../services/ComService'
import mainservice from '../../services/MainService'
import UserRegister from './UserRegister'
import { i18n } from '../../services/i18n'

enum Status {
  start,
  loading,
  credentialsWrong,
  forceToWait,
  forgotPassword,
  done
}

let failures: Date[] = [new Date(0), new Date(0), new Date(0)]
let reloadTimer: any = 0

const login = async (
  email: string,
  pw: string,
  setStatus: (s: Status) => void,
  setLoggedIn?: () => void
) => {
  const minute = 60 * 1000
  setStatus(Status.loading)
  mainservice.quitAdmin()
  const result = await mainservice.loginService.login(email, pw)
  console.log('login result', result)
  if (result === false) {
    failures.shift()
    failures.push(new Date())
    if (failures[0].getTime() + minute > new Date().getTime()) {
      reloadTimer = setTimeout(() => {
        clearTimeout(reloadTimer)
        setStatus(Status.credentialsWrong)
      }, minute)
      setStatus(Status.forceToWait)
      return false
    }
    setStatus(Status.credentialsWrong)
    return false
  }
  console.log('DONE?', setLoggedIn)
  if (setLoggedIn) {
    setLoggedIn()
  } else {
    mainservice.navTo([['view', 'dashboard']])
  }
    // setStatus(Status.done)
}

function ShowLoginFormular (props: {
  setStatus: (s: Status) => void,
  status: Status,
  setLoggedIn?: () => void,
  autofocus?: boolean,
}) {
  const setStatus = props.setStatus
  const [email, setEmail] = useState('')
  const [pw, setPw] = useState('')
  return <>
    <div className="w3-container lu-headline">
      {i18n('loginHeadline')}
    </div>

    <div className="w3-container">

      <label>{i18n('emailLabel')}</label>
      <input
        className="w3-input"
        type="text"
        autoFocus={ !!props.autofocus }
        value={ email || '' }
        onChange={ (event) =>setEmail(event.target.value) }
      />

      <label>{i18n('passwordLabel')}</label>
      <input
        className="w3-input"
        type="password"
        value={ pw || '' }
        onChange={(event) => setPw(event.target.value) }
        onKeyUp={(event) => {
          const code = (event as unknown as {code: string}).code
          if (code && code.search('Enter') > -1) {
            login(email, pw, setStatus, props.setLoggedIn)
          }
        }}
      />

      {
        props.status === Status.credentialsWrong &&
         <div className='w3-panel w3-pale-red w3-padding w3-border w3-border-red'>
          <p>{i18n('credentialsWrong')}</p>
          <p>{i18n('credentialsWrongHint')}</p>
          <ul>
            <li>{i18n('credentialsWrongHint1')}</li>
          </ul>
         </div>
      }

      <button
        className='w3-btn w3-ripple login-button'
        onClick={() => login(email, pw, setStatus, props.setLoggedIn)}
      >{ i18n('loginButton') }</button>
      <div>
        {i18n('forgotPasswordPhrase')} <button
          style={{ background: 'none', border: 'none', color: 'blue', textDecoration: 'underline', cursor: 'pointer', padding: 0 }}
          onClick={() => setStatus(Status.forgotPassword)}
        >{i18n('forgotPasswordButton')}</button>
      </div>
    </div>
  </>
}

function ShowContent (props: {
  setStatus: (s: Status) => void,
  status: Status,
  setLoggedIn?: () => void
}) {
  switch(props.status) {
    case Status.credentialsWrong:
    case Status.start:
      return <ShowLoginFormular
          setStatus={ (s: Status) => props.setStatus(s) }
          status={ props.status }
          setLoggedIn={ props.setLoggedIn }
        />
    case Status.loading:
      return <div className='w3-container'>
          <div className="w3-container lu-headline">
            {i18n('loginHeadline')}
          </div>
          <p className='w3-center'><Spinner
          mini={true}
          sizeClass='normalSize'
          /></p>
        </div>
    case Status.forceToWait:
      return <>
        <div className="w3-container lu-headline">
          {i18n('loginErrToManyTries')}
        </div>
        <div className="w3-container">
          <p>{i18n('loginErrToManyTriesHint')}</p>
          <p>{i18n('loginErrToManyTriesHint1')}</p>
          <ul>
            <li>{i18n('loginErrToManyTriesHint2')}</li>
          </ul>
          <p>{i18n('loginErrToManyTriesHint3')}</p>
        </div>
      </>
    case Status.done:
      return <>
          <div className="w3-container lu-headline">
            {i18n('loginSuccess')}
          </div>
          <div className="w3-container">
            <p>{i18n('loginSuccessHint')}</p>
          </div>
        </>
    case Status.forgotPassword:
      return <UserRegister
          showAsElement={true}
          mode={'forgotPassword'}
          className="forgotPassword"
        />
  }

  return null
}

function UserLogin (props: {
  showAsElement?: boolean,
  className?: string,
  setLoggedIn?: () => void
}) {
  const [status, setStatus] = useState(Status.start)
  if (props.showAsElement) {
    return <div className={`w3-card-4 lu-dialog ${props.className || ''}`}>
        <ShowContent
          setStatus={(s: Status) => { setStatus(s) }}
          status={ status }
          setLoggedIn={ props.setLoggedIn }
          />
      </div>
  }
  return <div className='w3-row'>
    <div className='w3-col l4 m3 s0'>&nbsp;</div>
    <div className="w3-card-4 lu-dialog w3-col l4 m6 s12">
      <ShowContent
        setStatus={(s: Status) => { setStatus(s) }}
        status={ status }
        setLoggedIn={ props.setLoggedIn }
        />
    </div>
  </div>
}

export default UserLogin
